<template name="LearnMoreButton">
    <button class="yellow-button selected" onClick={this.props.onClick} style.pointerEvents="auto">Learn More <span class="chevron chevron-learn-more" class.selected={this.props.selected}></span></button>
</template>
